var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarToStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.465 0.145874L26.4293 15.4245H42.4942L29.4975 24.8672L34.4618 40.1459L21.465 30.7032L8.46822 40.1459L13.4325 24.8672L0.43576 15.4245H16.5007L21.465 0.145874ZM21.465 8.29119L18.3294 17.9416H8.18242L16.3915 23.9058L13.2559 33.5562L21.465 27.5919L29.6741 33.5562L26.5385 23.9058L34.7476 17.9416H24.6006L21.465 8.29119Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarToStroke);
export default __webpack_public_path__ + "static/media/star_to_stroke.7271caaa4e712a0317a00e594d7b0eea.svg";
export { ForwardRef as ReactComponent };